import { http } from '@/shared/api'
import type { Language } from '@/shared/i18n'
import type { Viewer } from '../model/types'

export const viewerApi = {
  /** Профиль по подписи Telegram. Первый запрос создаёт пользователя на бэкенде. */
  getMe: async (signal?: AbortSignal): Promise<Viewer> => (await http.get<Viewer>('/app/me', { signal })).data,
  /** Ручной выбор языка: после него язык из Telegram профиль не перебивает. */
  chooseLanguage: async (language: Language): Promise<Viewer> =>
    (await http.patch<Viewer>('/app/me', { language })).data,
}
